import firebase from "firebase/app";
const firebaseConfig = {
  databaseURL: "https://meduberet-staging-2.firebaseio.com",
  apiKey: "AIzaSyBiCY6gRa-Ng6pR5QR6eT1PpJK-AujETmA",
  authDomain: "meduberet-staging-2.firebaseapp.com",
  projectId: "meduberet-staging-2",
  storageBucket: "meduberet-staging-2.appspot.com",
  messagingSenderId: "190319291205",
  appId: "1:190319291205:web:1d26087ff95f2499152c2c",
  measurementId: "G-ZVNF7V9CFD"
};
const firebaseApp = firebase.initializeApp(firebaseConfig);
//const baseUrl = "https://us-central1-meduberet-staging-2.cloudfunctions.net";
// const baseUrl = `http://localhost:5000/meduberet-project/us-central1`
const baseUrl = "https://us-central1-meduberet-project.cloudfunctions.net";
const db = firebaseApp.firestore();
const googleProvider = new firebase.auth.GoogleAuthProvider();
const facebookProvider = new firebase.auth.FacebookAuthProvider();
const auth = firebase.auth();
export { auth, db, baseUrl, googleProvider, facebookProvider };



//////////////////
// WEBPACK FOOTER
// ./firebaseConfig.js
// module id = 31
// module chunks = 23